import { CartItem } from '@/types/cart.types';
import { ProcedureTypeEnum } from '@/types/enums/procedure-type.enum';

export enum CartGroupTypeEnum {
  SINGLE = 'single',
  LABORATORY = 'laboratory',
  PROFESSIONAL = 'professional',
}

export interface CartItemGroup {
  id: string;
  type: CartGroupTypeEnum;
  items: CartItem[];
}

function getGroup(item: CartItem): Pick<CartItemGroup, 'id' | 'type'> | undefined {
  if (item.procedure.type === ProcedureTypeEnum.LABORATORY) {
    return {
      type: CartGroupTypeEnum.LABORATORY,
      id: ['laboratory', item.partner.facility.id, item.patient.id, item.slot.start, item.slot.end].join('|'),
    };
  }

  if (item.professional) {
    return {
      type: CartGroupTypeEnum.PROFESSIONAL,
      id: ['professional', item.professional.id].join('|'),
    };
  }

  return undefined;
}

export function groupCartItems(items: CartItem[]): CartItemGroup[] {
  const groups: CartItemGroup[] = [];
  const groupsById = new Map<string, CartItemGroup>();

  items.forEach((item) => {
    const candidate = getGroup(item);

    if (!candidate) {
      groups.push({ id: item.id, type: CartGroupTypeEnum.SINGLE, items: [item] });
      return;
    }

    const group = groupsById.get(candidate.id);

    if (group) {
      group.items.push(item);
      return;
    }

    const created: CartItemGroup = { ...candidate, items: [item] };

    groupsById.set(candidate.id, created);
    groups.push(created);
  });

  return groups.map((group) => (
    group.items.length > 1 ? group : { ...group, type: CartGroupTypeEnum.SINGLE }
  ));
}
